<template>
  <!-- Form -->
  <div class="careers-form" :class="{ '--loading': loading }">
    <FormKit data-matomo-name="careers" type="form" ref="formEl" :actions="false" @submit="onSubmit">
      <!-- Name -->
      <FormKit
        type="text"
        name="name"
        :label="$t('contacts.form.name')"
        validation="required"
        :placeholder="$t('contacts.form.name')"
      />

      <!-- Surname -->
      <FormKit
        type="text"
        name="surname"
        :label="$t('contacts.form.surname')"
        validation="required"
        :placeholder="$t('contacts.form.surname')"
      />

      <!-- Company -->
      <FormKit
        type="text"
        name="company"
        :label="`${$t('contacts.form.company')}`"
        :placeholder="$t('contacts.form.company')"
      />

      <!-- Email -->
      <FormKit
        type="email"
        name="email"
        :label="$t('contacts.form.email')"
        validation="required|email"
        :placeholder="$t('contacts.form.email')"
      />

      <!-- Telephone -->
      <FormKit
        type="text"
        name="phone"
        :label="$t('contacts.form.phone')"
        :placeholder="$t('contacts.form.phone')"
      />

      <!-- CV File Upload -->
      <FormKit
        type="file"
        :label="$t('contacts.form.fileUpload')"
        accept=".pdf"
        name="documents"
        :validation-rules="{ fileSize }"
        validation="required|fileSize"
        :validation-messages="{
          fileSize: $t('contacts.form.fileUploadSizeError'),
        }"
      >
        <template #noFiles>
          <span
            class="formkit-no-files"
            v-html="$t('contacts.form.fileUploadTxt')"
          />
        </template>
      </FormKit>

      <!-- Messaggio -->
      <FormKit
        type="textarea"
        name="note"
        :label="$t('contacts.form.note')"
        validation="required"
        :placeholder="$t('contacts.form.note')"
        rows="6"
      />

      <div class="form-row form-row-gdpr">
        <!-- GDPR Check (desktop) -->
        <div>
          <FormKit
            type="checkbox"
            name="gdpr"
            validation="accepted"
            :validation-messages="{
              accepted: $t('contacts.form.privacyError'),
            }"
          >
            <template #label="context">
              <p
                v-html="
                  $t('contacts.form.privacyCaption', {
                    url: localePath({
                      name: 'privacy-policy',
                    }),
                  })
                "
              />
            </template>
          </FormKit>
        </div>
      </div>

      <div class="m-top-m-1">
        <!-- Submit button -->
        <button type="submit" class="button-round-2">
          <span>{{ $t('contacts.careers.formCTA') }}</span>
        </button>
      </div>
    </FormKit>
  </div>
</template>

<script>
export default {
  name: 'ContactFormCarrers',
}
</script>

<script setup>
import { load } from 'recaptcha-v3'
import { reset } from '@formkit/core'

const runtimeConfig = useRuntimeConfig()
const emit = defineEmits(['form-sent', 'form-error'])
const { t } = useI18n()

const formEl = ref(null)
const loading = ref(false)

const postinApiId = t('contacts.careers.apiPostinId')

const onSubmitClick = () => {
  // retrieve the core node (several ways to do this):
  const node = formEl.value.node
  // submit the form!
  node.submit()
}

// Define custom validation function for file size
const fileSize = function (node) {
  if (!node.value || !node.value.length) return true // skip if no file
  const file = node.value[0].file
  const maxFileSizeInBytes = 2.5 * 1024 * 1024 // 2.5 MB
  return file.size <= maxFileSizeInBytes
}

const onSubmit = (formkitData, node) => {
  node.clearErrors()

  loading.value = true

  // TODO: Sistemare i catch del captcha da Postin. NON VIENE MAI ESEGUITO perchè ritorna un text.

  load(runtimeConfig.public.recaptchaKey).then((recaptcha) => {
    recaptcha.hideBadge()
    recaptcha.execute('careers').then((token) => {
      const formData = new FormData()

      formData.append('captcha', token)
      formData.append('api_id', postinApiId)

      formData.append('name', formkitData.name)
      formData.append('surname', formkitData.surname)
      formData.append('company', formkitData.company)
      formData.append('email', formkitData.email)
      formData.append('phone', formkitData.phone)
      formData.append(
        'documents',
        formkitData.documents[0].file,
        formkitData.documents[0].name,
      )
      formData.append('note', formkitData.note)
      formData.append('gdpr', formkitData.gdpr)

      // ID del template mail di postin
      fetch(runtimeConfig.public.postinURL, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          loading.value = false

          if (response.status === 200) {
            if (window._paq) {
              window._paq.push([
                'trackEvent',
                'Contact',
                'Careers Form Submitted',
                formkitData.email,
              ])
            }
            if (window?.dataLayer) {
              window.dataLayer.push({
                event: 'richiesta-lavora-con-noi',
              })
            }
            emit('form-sent')
            reset(node)
          } else {
            emit('form-error')
          }
        })
        .catch((e) => {
          loading.value = false
          emit('form-error')
        })
    })
  })
}
</script>

<style lang="scss">
@import './style.scss';
</style>
